import { useCallback } from 'react';
import { DICTIONARIES, type Language, type TranslationKey } from '@/constants/i18n';
import { useSettingsStore } from '@/store/settingsStore';

export function useI18n(): { t: (key: TranslationKey) => string; language: Language } {
  const language = useSettingsStore((s) => s.language);
  const t = useCallback(
    (key: TranslationKey) => DICTIONARIES[language][key] ?? DICTIONARIES.en[key],
    [language]
  );
  return { t, language };
}
